import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()

export const getHistory = () => history



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/history.js